<div class="container">
  <div class="recovery-container">
    <h2>Account Recovery</h2>
    <forgot-password *ngIf="mode == 'forgotPassword'" (submitEmail)="forgotPassword($event)" [error]="error"></forgot-password>
    <new-password *ngIf="mode == 'resetPassword'" (submitNewPassword)="forgotPasswordSubmit($event)"
      (resendCode)="forgotPassword()" [error]="error" [email]="email"></new-password>
    <link-sent *ngIf="mode == 'resetPasswordLinkSent'" [error]="error" (resendLink)="resendLink()"></link-sent>
    <recover-email *ngIf="mode == 'recoverEmail'" [error]="error" (resendLink)="resendLink()"></recover-email>
    <verify-email *ngIf="mode == 'verifyEmail'" [error]="error" (resendLink)="resendLink()"></verify-email>
    <reset-successful *ngIf="mode == 'resetSuccessful'"></reset-successful>
  </div>
</div>
